import { useTranslation } from "react-i18next";
import { FormAutocomplete, RowInfo } from "../../common";
import TextTransformationModal from "../modals/TextTransformationModal";

const Text = ({ useQuery, showSubtypeSelect = false }) => {
    const { t } = useTranslation();

    return (
        <>
            <p dangerouslySetInnerHTML={{ __html: t('Require the player to type words.') }} />
            {
                showSubtypeSelect
                    ? (
                        <RowInfo help={<TextTransformationModal />}>
                            <FormAutocomplete
                                label={t("Transformations")}
                                name="task_subtype"
                                useQuery={useQuery}
                                options={[
                                    { id: "0", name: t('None') },
                                    { id: "1", name: t('Generate image from submitted text using AI robot artist') },
                                ]}
                                size="small"
                                mode="clean"
                            />
                        </RowInfo>
                    )
                    : null
            }
        </>
    );
};

export default Text;
